import { createContext } from 'react';
import { Experiments } from '../types';

const ExperimentsContext = createContext<{
  experiments: Experiments | null;
  setExperiments: Function;
  abVariants: string[] | null;
}>({ experiments: null, abVariants: null, setExperiments: () => {} });

ExperimentsContext.displayName = 'ExperimentsContext';

export default ExperimentsContext;
